import initSlickWithArrowEvent from "../../components/slick-utils";

function initShopProductCategoryCarouselCategorySlick() {
    const slick = initSlickWithArrowEvent(
        $('.maier-wrapper-shop-product-category-carousel .maier-carousel-list'),
        {
            dots: false,
            dotsClass: 'slick-dots',
            prevArrow: '<span class="slide-arrow prev">Prev</span>',
            nextArrow: '<span class="slide-arrow next">Next</span>',
            autoplay: false,
            infinite: false,
            speed: 300,
            slidesToShow: 6,
            slidesToScroll: 6,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    },
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                }
            ]
        }
    );
}

document.addEventListener('DOMContentLoaded', initShopProductCategoryCarouselCategorySlick);

var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length >= 1) {
            initShopProductCategoryCarouselCategorySlick();
        }
    });
});

observer.observe(document.body, { attributes: false, childList: true, characterData: false, subtree: true });
